<template>
  <div>
    <h2 style="font-family: 'ColgateReady-BoldItalic'; color: #D71B16;">Día {{ dia.replace('dia', '') }}</h2>
    <input
      type="text"
      class="form-control mb-3"
      placeholder="Buscar cédula"
      v-model="busqueda"
      hidden
    />
    <UserTable
      :usuarios="usuariosFiltrados"
      :dia="dia"
      @actualizar="obtenerUsuarios"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import UserTable from '../components/UserTable.vue';
import api from '../services/api';

const route = useRoute();
const dia = route.params.dia;

const usuarios = ref([]);
const busqueda = ref('');

const obtenerUsuarios = async () => {
  const res = await api.get(`/usuarios/${dia}`);
  usuarios.value = res.data;
};

const usuariosFiltrados = computed(() =>
  usuarios.value.filter((u) =>
    u.cedula.toLowerCase().includes(busqueda.value.toLowerCase())
  )
);

onMounted(obtenerUsuarios);
</script>
